import { LOGIN_STATE, USER_INFO, LANG } from './constants'
// 去登录页授权登录
const redirectToLogin = function (isNeedBack = true) {
  let loginUrl = ''
  if (isNeedBack) {
    loginUrl =
      window.location.origin +
      '/m/login?autoLogout=1&backTo=' +
      window.location.pathname.replace('/m', '')
  } else {
    loginUrl = window.location.origin + '/m/login?autoLogout=1'
  }
  const appId =
    window.location.host.indexOf('provider') > -1
      ? 'wx4e55fbf116b4e297'
      : 'wx69e42477e2584da7'
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(
    loginUrl
  )}&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect`
}
// 获取设置语言
const getLang = function () {
  return localStorage.getItem(LANG) || 'zh-cn'
}
// 设置语言
const setLang = function (val) {
  return localStorage.setItem(LANG, val)
}
// 缓存用户信息
const cacheUserInfo = function (val = null) {
  return localStorage.setItem(USER_INFO, JSON.stringify(val))
}
// 获取缓存用户信息
const getUserInfo = function () {
  return JSON.parse(localStorage.getItem(USER_INFO)) || {}
}
// 获取会员信息
const getMemberInfo = function () {
  return JSON.parse(sessionStorage.getItem('currentBInfo') || '{}')
}
// 储存是否可申请理赔信息
const CAN_APPLY_CLAIM = 'can_apply_claim'
const setCanApplyClaim = function (val = null) {
  return localStorage.setItem(CAN_APPLY_CLAIM, val)
}
// 判断是否有申请理赔权限
const isCanApplyClaim = function () {
  return localStorage.getItem(CAN_APPLY_CLAIM) == '1' ? true : false
}
// 判断是否登录
const isLogined = function () {
  return localStorage.getItem(LOGIN_STATE) == 1
}
// 设置登录态
const setLogined = function (val) {
  return localStorage.setItem(LOGIN_STATE, val)
}
// 清除缓存
const clearLocal = function () {
  sessionStorage.removeItem('claimForm')
  sessionStorage.removeItem('claimUpload')
  sessionStorage.removeItem('preAuthForm')
  sessionStorage.removeItem('preAuthUpload')
  localStorage.getItem('welfareParams') &&
    localStorage.removeItem('welfareParams')
  localStorage.getItem('uploadParams') &&
    localStorage.removeItem('uploadParams')
  localStorage.getItem('policyPreInfo') &&
    localStorage.removeItem('policyPreInfo')
  sessionStorage.getItem('policyCliInfo') &&
    sessionStorage.removeItem('policyCliInfo')
  sessionStorage.getItem('hospitalsearch') &&
    sessionStorage.removeItem('hospitalsearch')
}
export default {
  redirectToLogin,
  getLang,
  setLang,
  cacheUserInfo,
  getUserInfo,
  getMemberInfo,
  setCanApplyClaim,
  isCanApplyClaim,
  isLogined,
  setLogined,
  clearLocal
}
